/* eslint-disable quote-props */
/**
 * Configure requireJS
 */
require([
  'blackbox',
  'jquery',
  'global.namespace',
  'cartridge',
  'digitalData',
  'global.digitalData_pattern',
  'hdc-widget-analytics',
  'auth.service',
  'secondary-data',
  'commission-junction',
  'PLPCART',
  'PLPBuyItAgain',
  'PLPQuantityBox',
  'video-overlay',
  'thd-client-throttle',
  'targeted.merchandise',
  'curationWidget',
  'verification.service',
  'global.modal',
  'account.list',
  'thd-cart-bindings',
  'categoryPaintVideo',
  'global.toolTip',
  'main.plp',
  'modernizr-custom',
  'PLPSEO',
  'exposeModulesForTnt',
], (
  blackbox,
  $,
  THD,
  cartridge,
  digitalDataWrapper,
  gddp,
  hwa,
  authService,
  secondaryData,
  commissionJunction,
  plpCart,
  plpBuyItAgain,
  quantityBox,
  videoOverlay,
  clientThrottle,
  targetedMerchandise,
  curationWidget,
  verificationService,
  globalModal,
  accountList,
  cartBindings,
  categoryPaintVideo,
) => {
  // eslint-disable-next-line no-param-reassign, no-multi-assign
  THD.PLP = THD.PLP || {};
  THD.BIA = THD.BIA || {};

  if (typeof THD_GLOBAL_APP !== 'undefined') {
    $.extend(THD_GLOBAL || {}, THD_GLOBAL_APP);
  }

  plpCart.init();
  quantityBox.init();
  categoryPaintVideo.init();

  if (THD.BIA.isBuyItAgainPage) {
    plpBuyItAgain.init();
    gddp.init();
    digitalDataWrapper.init();
  } else {
    // Curation Initialization
    curationWidget.init({
      dependencies: {
        'thd-cart-bindings': cartBindings,
        'account-global-ui': {
          'myList': accountList,
        },
      },
    });
    globalModal.init();
    secondaryData.init();
    authService.init();
    commissionJunction.updateCJInfo();
    gddp.init();
    digitalDataWrapper.init();
    hwa.init();
    cartridge.init();
    videoOverlay.init();
    targetedMerchandise.init();
    verificationService.init();
  }

  // edge includes has loads stuff through ajax if varnish isn not enabled
  $('.js-edgeinclude').each((i, el) => {
    const url = $(el).data('edgeinclude-url');

    $.ajax(url).done((res) => {
      $(el).html(res);
    });
  });
});
